import { env } from "../../../../../../config/EnvironmentConfig";
import type { ConfigApi } from "./ConfigApi";

function getAuthFromStorage(): { email: string; name: string } {
  const authToken = window.localStorage.getItem("auth_token");
  if (authToken) {
    try {
      const parsed = JSON.parse(authToken);
      return { email: parsed.email || "", name: parsed.name || "" };
    } catch {
      return { email: "", name: "" };
    }
  }
  return { email: "", name: "" };
}

export const defaultConfigApi = {
  get spUserEmail() {
    return getAuthFromStorage().email;
  },
  get userDisplayName() {
    return getAuthFromStorage().name;
  },
  get domain() {
    return env?.baseUrlCAT ?? env?.baseUrl ?? "";
  },
  xApiKey: "0471c3d0-56dd-4eb4-86bb-374fd022ac9b",
} as ConfigApi;

/** Build current config from localStorage (use when mounting CAT so headers have current user email). */
export function getCurrentCatConfig(): { baseURL: string; headers: Record<string, string> } {
  const { email, name } = getAuthFromStorage();
  return {
    baseURL: defaultConfigApi.domain,
    headers: {
      "userDisplayName": name,
      "email": email,
      "userloginname": email,
      "x-orig": "getCurrentCatConfig",
      "public-key": defaultConfigApi.xApiKey ?? "",
    },
  };
}